import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import {
    getProductTypeFromURL,
    getOutstandingInterest
} from '../../accountsSelector';

import { MoneyWithDecimals } from '../../../ui/moneyWithDecimals/index';
import messages from '../OutstandingView.messages';
import styles from './InterestAccrued.module.css';
import { RootState } from '@iwProvider/configureStore';

const mapStateToProps = (state: RootState) => ({
    interest: getOutstandingInterest(state, getProductTypeFromURL())
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const InterestAccrued = ({ interest }: PropsFromRedux) => (
    <div className={styles.interestAccrued}>
        <div className={styles.title}>
            <FormattedMessage {...messages.interestAccrued} />
        </div>
        <div className={styles.money}>
            <MoneyWithDecimals value={interest} />
        </div>
    </div>
);

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(InterestAccrued);
